import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../shared/auth-guard';
import { AddMemberComponent } from './add-member/add-member.component';
import { MemberListComponent } from './member-list/member-list.component';
import {MemberDetailComponent} from './member-detail/member-detail.component';
import { MemberDisableComponent } from './member-disable/member-disable.component';
import { MemberInactiveComponent } from './member-inactive/member-inactive.component';
const routes: Routes = [
    { path: 'member', component: MemberListComponent, canActivate: [AuthGuard] },
    { path: 'addmember', component: AddMemberComponent, canActivate: [AuthGuard] },
    { path: 'memberdetail', component: MemberDetailComponent, canActivate: [AuthGuard] },
    { path: 'activemember', component: MemberInactiveComponent, canActivate: [AuthGuard] },
    { path: 'disablemember', component: MemberDisableComponent, canActivate: [AuthGuard] }
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MemberRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/member/member-routing.module.ts